import React from 'react';
import {
    Card,
    WarningModal,
    SimpleTable,
    SimpleTableHeader,
    IEmptySectionProps,
} from 'components';
import { QualificationStatus } from './QualificationStatus';
import { IApiError } from '_helpers/ApiConnector/types';
import qualificationPlaceholderIcon from '../../assets/svg/qec/empty_certificate_icon.svg';
import moment from 'moment';

const Qualifications = ({
    qualificationsList,
    cardTitle,
    cardCategory,
    apiError,
    onQualificationListRowClick,
    onHideErrorModal,
    showErrorModal,
}: IProps) => {
    const emptyDataProps: IEmptySectionProps = {
        placeholderTitle: 'Нет присвоенных квалификаций',
        placeholderText: 'Здесь будут отображаться квалификации, присвоенные эксперту',
        placeholderButtonText: '',
        placeholderIcon: qualificationPlaceholderIcon,
    };

    const listTableHeaders: SimpleTableHeader[] = [
        { title: 'КВАЛИФИКАЦИЯ', columnStyles: { width: '100%' } },
        { title: 'СРОК ДЕЙСТВИЯ', columnStyles: { minWidth: '12rem' } },
        { title: 'СТАТУС' },
    ];

    const listTableRows = qualificationsList ? qualificationsList.map(({
        examApplicationId, title, issueDate, expireDate,
    }, i) => ({
        id: examApplicationId || i,
        columns: [
            title,
            `${issueDate.format('DD.MM.YYYY')} - ${expireDate.format('DD.MM.YYYY')}`,
            <QualificationStatus expireDate={expireDate} />,
        ],
    })) : [];

    const handleListRowClick = (examApplicationId: string | number) => {
        if (onQualificationListRowClick && qualificationsList) {
            onQualificationListRowClick(`${examApplicationId}`);
        }
    };

    return (
        <Card
          cardClassName="border-0"
          withoutPadding
          title={cardTitle}
          category={cardCategory}
          apiError={apiError}
        >
            <SimpleTable
              tableHeaders={listTableHeaders}
              tableRows={listTableRows}
              handleRowClick={handleListRowClick}
              {...emptyDataProps}
            />

            {apiError && showErrorModal !== undefined && onHideErrorModal ? (
                <WarningModal
                  title={apiError.message}
                  onHide={onHideErrorModal}
                  show={showErrorModal}
                />
            ) : null}
        </Card>
    );
};

export interface IProps {
    qualificationsList: IQualification[] | null;
    cardTitle: string;
    cardCategory: string;
    apiError: IApiError | null;
    showErrorModal?: boolean;
    onHideErrorModal?: () => void;
    onQualificationListRowClick?: (examApplicationId: string) => void;
}

export interface IQualification {
    applicantId: string;
    examId: string;
    examApplicationId: string;
    title: string;
    level: string;
    regNumber: string;
    expireDate: moment.Moment;
    issueDate: moment.Moment;
    certRegNumber: string;
    assigned?: boolean;
}

export default Qualifications;
